import { render, staticRenderFns } from "./FolderChildrenCount.vue?vue&type=template&id=5be800f5&scoped=true&"
import script from "./FolderChildrenCount.vue?vue&type=script&lang=js&"
export * from "./FolderChildrenCount.vue?vue&type=script&lang=js&"
import style0 from "./FolderChildrenCount.vue?vue&type=style&index=0&id=5be800f5&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5be800f5",
  null
  
)

export default component.exports